export enum ReportPeriod {
    LastWeek = 'lastWeek',
    LastMonth = 'lastMonth',
    LastYear = 'lastYear',
    Custom = 'custom',
}

export enum FileFormat {
    PDF = 'pdf',
    CSV = 'csv',
}
